<template>
  <v-container>
    <edit-time-form :data="time" />
  </v-container>
</template>

<script>
import EditTimeForm from "@/components/presumptive/EditTimeForm.vue";
import { mapState } from "vuex";

export default {
  components: {
    EditTimeForm,
  },
  computed: {
    ...mapState("Presumptive", ["time"]),
  },

  created() {
    this.$store.dispatch("Presumptive/getTimeDataEach", {
      column: "id",
      value: this.$route.params.id,
    });
  },
};
</script>
